import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import withFlags from './../components/WithFeatureFlags/component';
import { connect } from 'react-redux';
import { get } from 'lodash';
import ProgressBar from '../components/progressIndicator/component.js';
import * as homeActions from '../../client/home/actions.js';
import { bindActionCreators } from 'redux';
import * as apiHelper from '../common/helpers/apiHelper';
const DEFAULT_PAGE = 'gateway/cii';

const GateWayController = ({ flags, actions, configs }) => {

  const getQueryParams = () => {
    const query = new URLSearchParams(window.location.search);
    return {
      ciiEvolve: query.get('ciiEvolve'),
      redirectUrl: query.get('redirectUrl'),
      mode: query.get('mode'),
      aid: query.get('aid')
    };
  };

  const ssoBuildUrl = (profile, flags, configs) => {
    const ciiEvolveDetails = flags?.ssoAuthRedirectionDetails?.[0];
    const access = flags?.enableGCMEncryptionOnCIIAccessCIIDiscoverLinks
      ? decodeURIComponent(profile?.encryptedTaxId_AesGcm256)
      : profile?.encryptedTaxId_Aes256;
    const type = flags?.enableGCMEncryptionOnCIIAccessCIIDiscoverLinks
      ? ciiEvolveDetails?.ciiNewkeyType
      : ciiEvolveDetails?.ciiKeyOldType;
    const referrer = flags?.enableGCMEncryptionOnCIIAccessCIIDiscoverLinks
      ? ciiEvolveDetails?.ciiReferrerNewKey
      : ciiEvolveDetails?.ciiReferrerOldKey;
    const email = flags?.enableGCMEncryptionOnCIIAccessCIIDiscoverLinks
      ? decodeURIComponent(profile?.encryptedEmail_AesGcm256)
      : profile?.encryptedEmail_Aes256;
    const userEmail = flags?.enableGCMEncryptionOnCIIAccessCIIDiscoverLinks
      ? decodeURIComponent(profile?.encryptedUserEmail_AesGcm256)
      : profile?.encryptedUserEmail_Aes256;
    const ciiDiscoverUrl = configs?.urls?.ciiDiscover;
    const { ciiEvolve, redirectUrl, mode, aid } = getQueryParams();
    redirectSSOURL(ciiDiscoverUrl, {
      access,
      type,
      referrer,
      email,
      userEmail,
      ciiEvolve,
      redirectUrl,
      mode,
      aid,
    });
  };
  const redirectSSOURL = useCallback((ciiDiscoverUrl, inputs) => {
    const form = document.createElement('form');
    form.method = 'GET';
    form.action = ciiDiscoverUrl;
    form.style.display = 'none';

    Object.keys(inputs).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = inputs[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }, []);

  const fetchData = async () => {
    try {
      const { ciiEvolve, redirectUrl, mode, aid } = getQueryParams();
      apiHelper
        .getBPUserToken(true)
        .then(response => {
          setTimeout(() => {
            actions.fetchLoggedInUserProfile(DEFAULT_PAGE, true, false, {
              ciiEvolve,
              redirectUrl,
              mode,
              aid
            }).then(profile => {
              ssoBuildUrl(profile, flags, configs);
            });
          }, 3000);
        })
        .catch(() => {
          this.setState({ isLoading: false });
        });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="evolve-sso-container">
        <div className="whiteheader">
          <ProgressBar />
          <p className="text-center"> Please wait Redirecting.... </p>
        </div>
      </div>
    </>
  );
};

GateWayController.propTypes = {
  ciiDiscoverURL: PropTypes.string,
  flags: PropTypes.object.isRequired,
  configs: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    fetchLoggedInUserProfile: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  configs: get(state?.homeReducers, 'config.data'),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(homeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFlags(GateWayController));
